import {useUtilInformation} from 'components/hooks';
import useLoad from 'components/hooks/useLoad';
import {activity} from 'constants/url';

function useLoadAttended() {
  const {cwid} = useUtilInformation();
  return useLoad(activity, ['iD_Course', 'iD_Instance', 'iD_Sector'], {
    cwid: cwid,
  });
}

export default useLoadAttended;
